import { Box, NoData, Skeleton } from '@cast/design-system';
import { StorageAction } from '@cast/types-stop';

import { ResizeEventsTable } from '../_components/ResizeEventsTable';

type ActivityFeedProps = {
  storageActions: StorageAction[];
  isLoading?: boolean;
};

export const ActivityFeed = ({
  storageActions,
  isLoading,
}: ActivityFeedProps) => {
  return (
    <Box
      sx={{
        flex: 1,
        px: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {isLoading ? (
        <Skeleton variant="rectangular" width="100%" height="100%" />
      ) : storageActions.length > 0 ? (
        <ResizeEventsTable
          hideFirstAndLastColumnPaddings
          storageActions={storageActions.slice(0, 3)}
          sizing="m"
          sx={{
            '& .DS-Table-HeaderRowWrapper': {
              borderColor: 'divider',
            },
          }}
        />
      ) : (
        <NoData
          entity="storage activity"
          sx={{ flex: 1, justifyContent: 'center' }}
        />
      )}
    </Box>
  );
};
